// extracted by mini-css-extract-plugin
module.exports = {"ExitButton":"ExitButton_ExitButton__3YE18"};